var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 66,
    viewBox: "0 0 82 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON DIAMOND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65 12.5L77 9",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector ",
    d: "M57 45L62.5 56",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.1084 39.2212L0.999989 44.4988",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69 31.5L80.5 37",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.9473 52.4895L31.5535 65.0103",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "DIAMOND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.1937 41.6734L56.6266 24.3927L51.1592 10.326L27.6051 2.65535L15.6086 12.117L29.1937 41.6734Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.6091 12.1171L56.6271 24.3928",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.1935 41.6733L45.0785 20.5017L51.1591 10.3259",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.606 2.6554L29.8856 16.3908L29.1945 41.6735",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.1522 6.74316L45.0782 20.5019",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M29.8845 16.3908L40.1524 6.74313",
    stroke: "#EF7056",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamond);
export default __webpack_public_path__ + "static/media/icon-diamond.63d6c8ca8f5459fcfd2940648cb30b25.svg";
export { ForwardRef as ReactComponent };